import { LitElement, html, css } from 'lit';
import Chart from 'chart.js/auto';

export class CarouselChart extends LitElement {
  static properties = {
    chartData: { type: Array },
    fsym: { type: String },
  };

  constructor() {
    super();
    this.chartData = null;
    this.chart = null;
    this.fsym = null;
    this.colors = {
      'BCH': 'rgb(0,178,0)',
      'BTC': 'rgb(255,148,0)',
      'DOGE': 'rgb(225,179,3)',
      'ETH': 'rgb(114,123,213)',
      'LTC': 'rgb(165,173,185)',
      'SHIB': 'rgb(255,148,0)',
      'TON': 'rgb(0,152,324)',
      'USDC': 'rgb(38,161,123)',
      'USDT': 'rgb(38,161,123)',
      'XRP': 'rgb(0,205,192)'
    }
  }

  firstUpdated() {
    // console.log('firstUpdated:',this.chartData);
    if (this.chartData) {
      this.createChart();
    }
  }

  updated(changedProperties) {
    // console.log('updated:',this.chartData);
    if (changedProperties.has('chartData') && this.chartData) {
      this.createChart();
    }
  }

  createChart() {
    // console.log('createChart:',this.chartData);
    if (this.chart) {
      this.chart.destroy(); // Destroy the existing chart before creating a new one
    }

    const ctx = this.renderRoot.querySelector('canvas').getContext('2d');

    let gradient = ctx.createLinearGradient(0, 0, 0, 200);
    // gradient.addColorStop(0, 'rgba(255, 0, 0, 0.5)');
    // gradient.addColorStop(1, 'rgba(0, 0, 255, 0.5)');
    if (this.colors[this.fsym]) { gradient.addColorStop(0, this.colors[this.fsym]); }
    else { gradient.addColorStop(0, 'rgba(0, 0, 125, 0.5)'); }

    gradient.addColorStop(1, 'white');

    const data = {
      labels: this.chartData.map((_, index) => `Item ${index + 1}`),
      datasets: [{
        label: [],
        data: this.chartData,
        fill: true,
        backgroundColor: gradient,
        borderColor: this.colors[this.fsym],
        pointRadius: 0,
        tension: 0.1
      }]
    };

    const config = {
      type: 'line',
      data,
      options: {
        scales: {
          x: { display: false },
          y: { display: false },
        },
        plugins: {
          legend: { display: false },
        },
        maintainAspectRatio: false,
      }
    };

    this.chart = new Chart(ctx, config);
  }

  render() {
    return html`<canvas></canvas>`;
  }
}

customElements.define('carousel-chart', CarouselChart);
